export const CalendarIcon = () => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.86224 1.28544C4.86224 0.929185 4.55517 0.642578 4.17347 0.642578C3.79177 0.642578 3.48469 0.929185 3.48469 1.28544V2.35686H2.33673C1.32366 2.35686 0.5 3.12561 0.5 4.07115V4.49972V5.78544V12.6426C0.5 13.5881 1.32366 14.3569 2.33673 14.3569H11.5204C12.5335 14.3569 13.3571 13.5881 13.3571 12.6426V5.78544V4.49972V4.07115C13.3571 3.12561 12.5335 2.35686 11.5204 2.35686H10.3724V1.28544C10.3724 0.929185 10.0654 0.642578 9.68367 0.642578C9.30198 0.642578 8.9949 0.929185 8.9949 1.28544V2.35686H4.86224V1.28544ZM1.87755 5.78544H11.9796V12.6426C11.9796 12.8783 11.773 13.0711 11.5204 13.0711H2.33673C2.08418 13.0711 1.87755 12.8783 1.87755 12.6426V5.78544Z"
        fill="#797979"
      />
    </svg>
  );
};
